module.exports = __webpack_public_path__ + "static/img/flagpole.81fe8dc7.png";